import { render, staticRenderFns } from "./task-attachment.vue?vue&type=template&id=343396e0&"
import script from "./task-attachment.vue?vue&type=script&lang=js&"
export * from "./task-attachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('343396e0')) {
      api.createRecord('343396e0', component.options)
    } else {
      api.reload('343396e0', component.options)
    }
    module.hot.accept("./task-attachment.vue?vue&type=template&id=343396e0&", function () {
      api.rerender('343396e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/task/task-attachment.vue"
export default component.exports